<template>
  <PForm
    ref="pForm"
    :heading="`My Past Payments`"
    :primary-cta="submitButton"
    :secondary-cta="secondaryCta"
    @close="closeForm"
  >
    <div v-if="loading" class="q-my-md">
      <p>Loading...</p>
    </div>
    <q-card
      v-for="(paymentInfo, index) in pastPayments"
      v-else
      :key="index"
      flat
      :style="{
        minWidth: 'auto',
      }"
      class="relative-position q-mt-xxl"
    >
      <q-card-section class="q-pa-none">
        <div class="flex q-mb-xs items-center justify-between">
          <div>
            <span class="text-weight-bold text-md">
              {{ paymentInfo.internal_number }}
            </span>
          </div>
          <div>
            <div class="text-right">
              <PBadge
                :label="getStatus(paymentInfo.status_cd)"
                :type="getStatus(paymentInfo.status_cd)"
                class="text-capitalize"
              />
            </div>
          </div>
        </div>
        <q-separator />
        <div class="row q-mb-md q-my-sm">
          <div class="col-3">
            <p class="q-mb-xxs text-weight-regular text-sm text-neutral-80">
              Vendor :
            </p>

            <p class="q-mb-xxs text-weight-regular text-sm text-neutral-80">
              Type of Payment :
            </p>
            <p class="q-mb-xxs text-weight-regular text-sm text-neutral-80">
              Created At :
            </p>
            <p class="q-mb-xxs text-weight-regular text-sm text-neutral-80">
              Net Payable :
            </p>
            <p class="q-mb-xxs text-weight-regular text-sm text-neutral-80">
              Purchase Bill :
            </p>
            <p class="q-mb-xxs text-weight-regular text-sm text-neutral-80">
              Invoice# :
            </p>
            <p class="q-mb-xxs text-weight-regular text-sm text-neutral-80">
              Approvers:
            </p>
          </div>
          <div class="col-9">
            <p class="q-mb-xxs text-weight-regular text-sm">
              {{ paymentInfo?.seller_info?.shop_name || "-" }}
            </p>
            <p class="q-mb-xxs text-weight-regular text-sm">
              {{
                paymentInfo?.is_advance ? "Vendor Advance" : "Vendor Payment"
              }}
            </p>
            <p class="q-mb-xxs text-weight-regular text-sm">
              {{ formatDate(paymentInfo.created_date, "DD MMM, YYYY HH:MM A") }}
            </p>
            <p class="q-mb-xxs text-weight-regular text-sm">
              {{
                numberFormat({
                  number: paymentInfo?.net_payable || 0,
                  style: "currency",
                })
              }}
            </p>
            <p class="q-mb-xxs text-weight-regular text-sm">
              {{ paymentInfo?.bill_number || "-" }}
            </p>
            <p class="q-mb-xxs text-weight-regular text-sm">
              {{ paymentInfo?.invc_number || "-" }}
            </p>
            <p class="q-mb-xxs text-weight-regular text-sm">
              {{ approversInfo(paymentInfo?.approvers) }}
            </p>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </PForm>
</template>

<script setup>
import { numberFormat } from "assets/scripts/utilities/helpers";
import { date } from "quasar";
import { useChangeCase } from "@vueuse/integrations/useChangeCase";

import { usePaymentsStore } from "src/stores/payments";

const { formatDate } = date;

const submitButton = ref({});
const secondaryCta = ref({});

const loading = ref(false);

const { pastPayments } = storeToRefs(usePaymentsStore());

const { togglePastPaymentRequestsView, getPastPaymentRequests } =
  usePaymentsStore();

const getStatus = (status_cd) => {
  if (!status_cd) {
    return "-";
  }

  return useChangeCase(status_cd, "capitalCase").value;
};
const approversInfo = (approvers) =>
  approvers
    ?.map((approver) => `${approver.name}: ${getStatus(approver.status_cd)}`)
    .join(", ");

watchEffect(async () => {
  await getPastPaymentRequests({});
});

const closeForm = () => {
  togglePastPaymentRequestsView({
    open: false,
  });
};
</script>
